import { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../redux/actions/authActions";
import SidebarItem from "./sidebarItem";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";
import LogoutModal from "../modals/logoutModal";
import logoutLogo from "../../../assets/icons/sidebar/signOut.svg";
import userLogo from "../../../assets/icons/sidebar/userProfile.svg";

const SidebarComponent = ({ userPermissionList, sidebarConfig }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("userType");

  const [logoutShow, setLogoutShow] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();

  const activePath = "/" + location.pathname.split("/")[1];
  const activeSubPath = "/" + location.pathname.split("/")[2];

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const logoutSuccess = (data) => {
    setShowSuccessMsg(capitalize(data.data.message));
    setShowSuccessPopup(true);
    setTimeout(() => navigate("/"), 2000);
  };

  const logoutError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  return (
    <div className="">
      <div className="nav-container p-3 d-flex flex-column justify-content-between mx-0">
        <ul className="nav-options">
          {sidebarConfig.map((item) =>
            typeof item.visible === "function"
              ? item.visible({ userType, userPermissionList }) && (
                  <SidebarItem
                    key={item.label}
                    item={item}
                    activePath={activePath}
                    activeSubPath={activeSubPath}
                    navigate={navigate}
                  />
                )
              : null
          )}
        </ul>
        <div className="contact-div">
          <div
            className={`nav-items d-flex justify-content-start align-items-center  px-2 `}
            onClick={() => {
              setLogoutShow(true);
            }}
          >
            <img src={userLogo} />
            <div className="logout-div">
              <span className="nav-text-2">Logout</span>
              <img src={logoutLogo} />
            </div>
          </div>
        </div>
      </div>
      <LogoutModal
        logoutShow={logoutShow}
        handleLogoutClose={() => setLogoutShow(false)}
        logoutFunc={logoutHandler}
      />
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </div>
  );
};
export default SidebarComponent;
